<template>
  <div id="insurance-change" class="app">
    <Icons />
    <div class="app__logo">
      <img src="logo.svg">
    </div>
    <div class="app__content">
      <div class="app__barwindow"></div>
      <ProgressBar :step="step" class="app__bar"/>
      <Form class="app__form" :step="step" />
      <div class="app__right">
        <InfoText />
        <SaveBtn class="app__save" />
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import Form from './components/Form.vue'
import InfoText from './components/InfoText.vue'
import smoothscroll from 'smoothscroll-polyfill'
import ProgressBar from './components/ProgressBar.vue'
import SaveBtn from './components/ui/SaveBtn.vue'
import Icons from './components/Icons.vue'

export default {
  components: { InfoText, Form, ProgressBar, SaveBtn, Icons },
  name: 'App',
  created(){
    this.$store.commit('setStepsData', new Array(this.$store.getters.steptitles.length).fill(0).map(()=>({})))
    smoothscroll.polyfill()
    this.$store.dispatch('initMetrika')
  },
  computed: {
    ...mapState(['step']),
  }
}
</script>

<style lang="sass">
.fastfade-enter-active, .fastfade-leave-active 
  transition: opacity .1s ease-out
  transition-delay: 0

.fade-enter-active, .fade-leave-active 
  transition: opacity .4s ease-out
.fade-enter, .fade-leave-to, .fastfade-enter, .fastfade-leave-to
  opacity: 0
.expand-enter-active,.expand-leave-active 
  transition-property: opacity .4s ease-out, height .4s ease-out

.expand-enter,.expand-leave-to 
  opacity: 0


body
  background: colors.$light
  margin: 0
h1,h2,h3,h4,h5,h6,p
  margin: 0
legend 
  padding: 0
  display: table
fieldset 
  border: 0
  padding: 0.01em 0 0 0
  margin: 0
  min-width: 0
body:not(:-moz-handler-blocked) fieldset 
  display: table-cell

#insurance-change 
  *
    font-family: fonts.$font
    box-sizing: border-box
    letter-spacing: 0.01em
  .btn
    font-family: 'Montserrat'
    letter-spacing: normal
  svg, img
    display: block
.app
  --titleheight: 64px
  --logoheight: 47px
  --apppadd: 32px
  padding: 32px 64px 64px
  @include from(1300px)
    padding: 30px
    --apppadd: 30px
    &__form
      padding: 30px 0
  @include from(800px)
    padding: 15px
    --apppadd: 15px
  &__logo
    position: relative
    z-index: 2
    img
      height: var(--logoheight)
      transform-origin: left center
  &__barwindow
    width: 17% 
    position: absolute
    top: 0
    left: 0
    z-index: 1
    height: calc(var(--appcontentmargin) + var(--apppadd) + var(--logoheight) + var(--titleheight))
    background: linear-gradient(180deg, colors.$light 0%, colors.$light calc(100% - var(--titleheight)), transparentize(colors.$light,1) 100%)
    
  &__content
    --appcontentmargin: 160px
    margin-top: var(--appcontentmargin)
    padding-top: var(--titleheight)
    display: flex
    min-height: calc(100vh - var(--appcontentmargin) - var(--titleheight) - var(--logoheight))
    @include from(1300px)
      min-height: 0vh
  &__bar
    margin-top: 0px
    position: sticky
    top: 16px
    align-self: flex-start
    margin-left: 53px
    margin-right: 25px
    flex-basis: 17%
    @include from(1500px)
      margin-left: 0
      width: 40px
      min-width: 40px
      .progressbar__step>span>span:first-child
        display: none !important
    @include from(1300px)
      .progressbar__step>span
        display: none !important
    @include for-mob
      margin-right: 0
    @include from(480px)
      display: none

  &__form
    flex-basis: 816px
    max-width: 816px
  &__right
    flex-grow: 1
  &__save
    margin-top: 40px
    position: sticky
    top: calc(100% - 54px - 32px) 
    margin-left: auto
  &__right
    margin-left: 32px
  @include from(1300px)
    &__form
      flex-grow: 1
      min-width: 600px
    .form__step
      padding: 0 40px
    &__right
      width: 250px
    &__content
      --appcontentmargin: 100px
  @include from(1050px)
    &__right
      display: none
  @include for-mob
    .form__step
      padding: 0 30px
    &__form
      padding-top: 15px
      min-width: 0px
  @include from(480px)
    --titleheight: 40px
    .form__step
      padding: 0 20px
    .form__title
      bottom: initial
      top: 15px
      font-size: 24px
      line-height: 1.3
      left: 20px
      color: colors.$brown
    &__content    
      --appcontentmargin: 0
      margin: 0 -15px 40px
</style>
